export default __webpack_public_path__ + "static/media/misc-bathtubA-1920w.4e4bda33.avif";